import { WSProps } from './SocketManager.interface';
import { WS } from './Websocket';

export class SocketManager {
	socket: WS | null = null;
	WS_URL: string = '';

	init({
		WS_URL,
		GameConfigs,
		receiveMessage,
		errorHandler,
		onCallError
	}: WSProps) {
		this.socket = new WS({
			WS_URL,
			GameConfigs,
			receiveMessage,
			errorHandler,
			onCallError
		});

		return this.socket;
	}
}
